module.exports = "\n<div class=\"wrapper\">\n  <app-navbar></app-navbar>\n  <app-sidemenu></app-sidemenu>\n  <div class=\"content\">\n  \t<router-outlet></router-outlet>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/public/public.component.html
// module id = ./src/app/public/public.component.html
// module chunks = main